/*jshint esversion: 8 */
import { fetchPost } from './RequestHandler';

// 查询交易
const getTrades = async (data) => {
  const rst = await fetchPost('/web_trade/getTrades', { data });
  return rst;
};

// 退回销售
const returnOrder = async (data) => {
  const rst = await fetchPost('/web_trade/returnOrder', { data });
  return rst;
};


// 取消订单
const cancelOrder = async (data) => {
  const rst = await fetchPost('/web_trade/cancelOrder', { data });
  return rst;
};

// 动迁办确认
const relocateOfficeConfirm = async (data) => {
  const rst = await fetchPost('/web_trade/relocateOfficeConfirm', { data });
  return rst;
};

// 财资审核
const financeOfficeConfirm = async (data) => {
  const rst = await fetchPost('/web_trade/financeOfficeConfirm', { data });
  return rst;
};

// 获取交易统计
const getTradeStatistics = async (data) => {
  const rst = await fetchPost('/web_trade/getTradeStatistics', { data });
  return rst;
};

// 获取附件
const getImageUrls = async (data) => {
  const rst = await fetchPost('/web_trade/getImageUrls', { data });
  return rst;
};

export {
  getTrades,
  returnOrder,
  cancelOrder,
  relocateOfficeConfirm,
  financeOfficeConfirm,
  getTradeStatistics,
  getImageUrls,
};
